import React from 'react';
import { Card, Spinner, Alert } from 'react-bootstrap';
import { useGetContentQuery } from '../../store';

const TACL = "PRIVACY_POLICY_APPRAISER";

const PP = () => {
    const {
        data: content,
        isLoading: isContentLoading,
        isError: isContentError,
        error: contentError,
        isSuccess: isContentSuccess,
        refetch,
    } = useGetContentQuery(TACL);

    return (
        <div className='container py-5'>
            <h1>Privacy Policy</h1>
            {/* <Card border='0px'>
                <Card.Body border='0px'> */}
            {isContentLoading && <Spinner animation="border" />}
            {isContentError && (
                <Alert variant="danger">
                    {contentError?.data?.message || "An error occurred while fetching the privacy policy."}
                </Alert>
            )}
            {isContentSuccess && content && (
                <div
                    style={{ overflowY: "auto" }}
                    dangerouslySetInnerHTML={{ __html: content.content.content }}
                />
            )}
            {!isContentLoading && !isContentError && !content && (
                <Alert variant="warning">No content available.</Alert>
            )}
            {/* </Card.Body>
            </Card> */}
        </div>
    );
}

export default PP;